"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
// TODO: Migrate all DF styles over to here
const color_1 = __importDefault(require("color"));
const text = (0, color_1.default)('#bbb').hex();
exports.colors = {
    text,
};
